import { render, staticRenderFns } from "./TipsTransition.vue?vue&type=template&id=6431fb54&"
import script from "./TipsTransition.vue?vue&type=script&lang=js&"
export * from "./TipsTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports